import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const DeleteModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
`;

export const DeleteModalHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px 16px 0;
`;

export const DeleteModalClose = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #9097A3;
    
    &:hover {
        color: ${colors.darkGray1};
    }
`;

export const DeleteModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 8px 32px 64px;
    gap: 4px;
    border-bottom: 1px solid #F1F3F5;
`;

export const WarningIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    
    svg {
        width: 48px;
        height: 48px;
    }
`;

export const DeleteModalTitle = styled.h2`
    font-weight: 500;
    font-size: 18px;
    line-height: 1.33;
    color: ${colors.darkGray1};
    margin: 0;
`;

export const DeleteModalNote = styled.div`
    font-weight: 450;
    font-size: 14px;
    line-height: 1.43;
    color: ${colors.darkGray2};
`;

export const DeleteModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 12px 24px;
    background: #ffffff;
`;

export const CancelButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 24px;
    background: transparent;
    border: 1px solid ${colors.gray3};
    border-radius: 8px;
    cursor: pointer;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.43;
    color: ${colors.darkGray1};
    transition: background-color 0.2s ease;
    
    &:hover {
        background: ${colors.gray4};
    }
`;

export const DeleteButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 24px;
    background: #E53E3E;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.43;
    color: #ffffff;
    transition: background-color 0.2s ease;
    
    &:hover {
        background: #C53030;
    }
    
    svg {
        width: 24px;
        height: 24px;
    }
`; 